/**
 * @generated SignedSource<<14419a6372a567f7d9e22229bf5ba3aa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type issueRow_nativeIssueTable_IssueRowWithFragments_issue$data = {
  readonly childIssues?: {
    readonly issues?: {
      readonly totalCount: number | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly fieldSetsById?: {
    readonly " $fragmentSpreads": FragmentRefs<"issueRow_nativeIssueTable_IssueRowWithFragments_fieldSetsForIssueSearchView">;
  };
  readonly fieldSetsForIssueSearchView?: {
    readonly " $fragmentSpreads": FragmentRefs<"issueRow_nativeIssueTable_IssueRowWithFragments_fieldSetsForIssueSearchView">;
  };
  readonly issueId: string;
  readonly key: string;
  readonly " $fragmentType": "issueRow_nativeIssueTable_IssueRowWithFragments_issue";
};
export type issueRow_nativeIssueTable_IssueRowWithFragments_issue$key = {
  readonly " $data"?: issueRow_nativeIssueTable_IssueRowWithFragments_issue$data;
  readonly " $fragmentSpreads": FragmentRefs<"issueRow_nativeIssueTable_IssueRowWithFragments_issue">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "amountOfColumns"
},
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "isInlineEditingEnabled",
        "variableName": "isInlineEditingEnabled"
      }
    ],
    "kind": "FragmentSpread",
    "name": "issueRow_nativeIssueTable_IssueRowWithFragments_fieldSetsForIssueSearchView"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcischildissuestotalcountenabledrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "amountOfColumns"
    },
    {
      "kind": "RootArgument",
      "name": "fieldSetIds"
    },
    {
      "kind": "RootArgument",
      "name": "filterId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    },
    {
      "kind": "RootArgument",
      "name": "namespace"
    },
    {
      "kind": "RootArgument",
      "name": "shouldQueryFieldSetsById"
    },
    {
      "kind": "RootArgument",
      "name": "viewId"
    }
  ],
  "kind": "Fragment",
  "name": "issueRow_nativeIssueTable_IssueRowWithFragments_issue",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "kind": "ScalarField",
      "name": "issueId"
    },
    {
      "condition": "shouldQueryFieldSetsById",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "args": [
              {
                "kind": "Variable",
                "name": "fieldSetIds",
                "variableName": "fieldSetIds"
              },
              (v0/*: any*/)
            ],
            "concreteType": "JiraIssueFieldSetConnection",
            "kind": "LinkedField",
            "name": "fieldSetsById",
            "plural": false,
            "selections": (v1/*: any*/)
          },
          "action": "THROW",
          "path": "fieldSetsById"
        }
      ]
    },
    {
      "condition": "shouldQueryFieldSetsById",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "args": [
              {
                "kind": "Variable",
                "name": "filterId",
                "variableName": "filterId"
              },
              (v0/*: any*/),
              {
                "kind": "Variable",
                "name": "namespace",
                "variableName": "namespace"
              },
              {
                "kind": "Variable",
                "name": "viewId",
                "variableName": "viewId"
              }
            ],
            "concreteType": "JiraIssueFieldSetConnection",
            "kind": "LinkedField",
            "name": "fieldSetsForIssueSearchView",
            "plural": false,
            "selections": (v1/*: any*/)
          },
          "action": "THROW",
          "path": "fieldSetsForIssueSearchView"
        }
      ]
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcischildissuestotalcountenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "childIssues",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "activeProjectsOnly",
                      "value": true
                    },
                    {
                      "kind": "Literal",
                      "name": "first",
                      "value": 10
                    }
                  ],
                  "concreteType": "JiraIssueConnection",
                  "kind": "LinkedField",
                  "name": "issues",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "totalCount"
                    }
                  ],
                  "storageKey": "issues(activeProjectsOnly:true,first:10)"
                }
              ],
              "type": "JiraChildIssuesWithinLimit"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraIssue"
};
})();

(node as any).hash = "cb55e8ab8687e07c241360c85510346c";

export default node;
